export default function HowItWorks() {
  const steps = [
    {
      icon: 'ri-search-line',
      step: '01',
      title: 'Find Your Vehicle',
      description: 'Browse our inventory and find the perfect vehicle for your needs. Every vehicle is thoroughly inspected and comes with our honest pricing.'
    },
    {
      icon: 'ri-chat-smile-2-line',
      step: '02',
      title: 'Just Tell Us You Served',
      description: 'That\'s it. No DD-214. No military ID required. No verification process. Just let us know — or ask us about it — and the discount is yours. We take your word for it.'
    },
    {
      icon: 'ri-hand-heart-line',
      step: '03',
      title: 'Choose Your Benefit',
      description: 'Take $300 off the vehicle price, or donate the full $300 to any charity of your choosing. The choice is completely yours.'
    },
    {
      icon: 'ri-key-2-line',
      step: '04',
      title: 'Drive Home',
      description: 'Complete your purchase with the discount applied or donation confirmed. We handle all the paperwork and make it easy.'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 text-white relative overflow-hidden">
      {/* Subtle camo-inspired diagonal stripe accent */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            #ffffff 0px,
            #ffffff 2px,
            transparent 2px,
            transparent 24px
          )`,
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">How the Dog Tag Discount Works</h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">
            Four simple steps. No paperwork. No hassle. Just respect.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+2.5rem)] w-[calc(100%-5rem)] h-px bg-gradient-to-r from-red-700/60 to-red-700/20 z-0"></div>
              )}
              <div className="relative z-10 flex flex-col items-center text-center bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 hover:border-red-700/50 transition-all hover:bg-slate-800/80">
                {/* Step badge — styled like military rank patch */}
                <div className="relative mb-5">
                  <div className="w-20 h-20 bg-gradient-to-br from-red-700 to-red-900 rounded-full flex items-center justify-center shadow-lg shadow-red-900/40 border-2 border-red-600/50">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="absolute -top-1 -right-1 w-7 h-7 bg-slate-900 border border-yellow-500/70 rounded-full flex items-center justify-center">
                    <span className="text-yellow-400 text-xs font-black">{step.step}</span>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                  {step.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-sm">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom honor strip */}
        <div className="mt-14 flex items-center justify-center gap-4">
          <div className="h-px flex-1 max-w-xs bg-gradient-to-r from-transparent via-red-700/40 to-transparent"></div>
          <div className="flex items-center gap-2 text-slate-500 text-sm font-semibold tracking-widest uppercase">
            <i className="ri-shield-star-fill text-red-600"></i>
            <span>Honoring Every Branch</span>
            <i className="ri-shield-star-fill text-red-600"></i>
          </div>
          <div className="h-px flex-1 max-w-xs bg-gradient-to-r from-transparent via-red-700/40 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
